import cn from 'classnames';
import { MoreVertical } from 'seagull/icons';
import { Badge, Button, DropdownMenu, IconButton, Skeleton, Typography } from 'seagull';
import { getRenderedMenuItem } from "./ManagePaymentMethods.utils";
import { useFeatureFlags } from "../../hooks/useFeatureFlags";
import styles from "./PaymentMethodPanel.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function PaymentMethodPanel(props) {
  const {
    isSelected,
    removable,
    disconnectable,
    selectable,
    logo,
    title,
    description,
    footer,
    isMobile,
    onSelect,
    onRemove,
    onDisconnect
  } = props;
  const RootElement = isMobile ? 'button' : 'div';
  const menuItem = getRenderedMenuItem({
    disconnectable: !!disconnectable,
    removable: !!removable,
    isSelected,
    onDisconnect,
    onRemove
  });
  const {
    PAYMENT_METHODS_CHANGE_ANIMATION
  } = useFeatureFlags();
  return /*#__PURE__*/_jsxs(RootElement, {
    className: cn(styles.paymentMethod, {
      [styles.selected]: isSelected,
      [styles.isMobile]: isMobile,
      [styles.fullWidth]: PAYMENT_METHODS_CHANGE_ANIMATION
    }),
    "data-testid": "manage-payment-methods-payment-method",
    onClick: selectable && isMobile ? onSelect : undefined,
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.inner,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.logo,
        children: logo
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.content,
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "h6",
          weight: "light",
          children: title
        }), /*#__PURE__*/_jsx(Typography, {
          "data-testid": "manage-payment-methods-payment-method-details",
          variant: "paragraph1",
          weight: "light",
          skin: "secondary",
          children: description
        })]
      }), isSelected ? /*#__PURE__*/_jsx(Badge, {
        className: styles.selectedBadge,
        rounded: true,
        outlined: true,
        skin: "primary",
        "data-testid": "manage-payment-methods-payment-method-selected",
        children: "Selected"
      }) : selectable && !isMobile && /*#__PURE__*/_jsx(Button, {
        className: styles.selectBtn,
        "data-testid": "payment-method-select-btn",
        skin: "primaryOutline",
        size: "small",
        onClick: onSelect,
        children: "Select for this agreement"
      })]
    }), /*#__PURE__*/_jsx(DropdownMenu, {
      target: /*#__PURE__*/_jsx(IconButton, {
        className: styles.removeBtn,
        skin: "transparent",
        "data-testid": "payment-method-dropdown",
        children: /*#__PURE__*/_jsx(MoreVertical, {})
      }),
      children: /*#__PURE__*/_jsx(DropdownMenu.Item, {
        skin: menuItem.skin,
        "data-testid": "payment-method-".concat(menuItem.type, "-btn"),
        onClick: menuItem.onClick,
        disabled: menuItem.disabled,
        tooltipProps: menuItem.disabledTooltipText ? {
          title: menuItem.disabledTooltipText,
          'data-testid': 'disabled-remove-tooltip'
        } : undefined,
        children: menuItem.text
      })
    }), footer && /*#__PURE__*/_jsx("div", {
      className: styles.footer,
      children: footer
    })]
  });
}
export function PaymentMethodPanelSkeleton(_ref) {
  let {
    isMobile
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: cn(styles.paymentMethod, {
      [styles.isMobile]: isMobile
    }),
    "data-testid": "manage-payment-methods-payment-method-skeleton",
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.inner,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.logo,
        children: /*#__PURE__*/_jsx(Skeleton, {
          height: 42,
          width: "100%"
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.content,
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "h6",
          weight: "light",
          children: /*#__PURE__*/_jsx(Skeleton, {
            height: 35,
            width: "100%",
            style: {
              marginBottom: 8
            }
          })
        }), /*#__PURE__*/_jsx(Typography, {
          "data-testid": "manage-payment-methods-payment-method-details",
          variant: "paragraph1",
          weight: "light",
          skin: "secondary",
          children: /*#__PURE__*/_jsx(Skeleton, {
            height: 24,
            width: "100%"
          })
        })]
      })]
    })
  });
}